import type { SessionResponse, Unternehmen } from "@kundeninfo/api-client";

export type Benutzer = NonNullable<SessionResponse["user"]>;

export type Sitzung = {
  user: Benutzer;
  companies: Unternehmen[];
};

/**
 * Das Unternehmen, dem der Benutzer zugeordnet ist — für Logo und Farbakzent im Kopf.
 * Ohne Zuordnung (homeCompanyId fehlt oder verweist auf kein sichtbares Unternehmen)
 * gibt es kein Logo; der Kopf zeigt dann nur den Schriftzug "Kundeninfo".
 */
export function homeCompany(sitzung: Sitzung): Unternehmen | null {
  const id = sitzung.user.homeCompanyId;
  if (id === undefined || id === null) return null;
  return sitzung.companies.find((c) => c.id === id) ?? null;
}
